import React from 'react';
import StockTransferChart from './components/SKUWiseTransfer';
import CountComponent from './components/CountComponent';

const HomeComponent = () => {
  return (
    <>
    <div style={{
        display:'flex'
      }}>
      <CountComponent text={"SKU Valuation : "} apiurl={'GetTotalTransferValue'} />
      <CountComponent text={"Units : "} apiurl={'GetTotalTransfer'} />
      </div>
      <StockTransferChart />
      </>
  );
};

export default HomeComponent;


